import React, { forwardRef, useImperativeHandle } from "react";
import { FormProvider, useForm } from "react-hook-form";

import {
  PersonalAreaProfileFormFields,
  PersonalAreaProfileFormFieldsProps,
} from "../forms-fields/personal-area-profile-form-fields";
import {
  PersonalAreaProfileFormFieldsLabels,
  PersonalAreaProfileFormFieldsTypes,
} from "../forms-fields/personal-area-profile-form-fields/types";
import { PrivacyFormFields, PrivacyFormFieldsProps } from "../forms-fields/privacy-form-fields";
import { SubmitButton } from "../request-info-form/submit-button";

export interface PersonalAreaProfileFormProps
  extends Pick<
      PersonalAreaProfileFormFieldsProps,
      "materialsList" | "statesList" | "businessRelationshipList" | "countriesList"
    >,
    Pick<PrivacyFormFieldsProps, "consents"> {
  labels: PersonalAreaProfileFormFieldsLabels;
  onSubmit: (values: PersonalAreaProfileFormFieldsTypes) => void;
  defaultValues?: Partial<PersonalAreaProfileFormFieldsTypes>;
}

export interface PersonalAreaProfileFormHandle {
  resetForm: (values?: Partial<PersonalAreaProfileFormFieldsTypes>) => void;
}

export const PersonalAreaProfileForm = forwardRef<
  PersonalAreaProfileFormHandle,
  PersonalAreaProfileFormProps
>(
  (
    {
      labels,
      consents,
      onSubmit,
      defaultValues,
      businessRelationshipList,
      countriesList,
      materialsList,
      statesList,
    },
    ref
  ) => {
    const formMethods = useForm<PersonalAreaProfileFormFieldsTypes>({
      mode: "onBlur",
      reValidateMode: "onChange",
      defaultValues: {
        ...defaultValues,
      },
    });

    const {
      formState: { isValid: isFormValid },
    } = formMethods;
    const isSubmitDisabled = isFormValid;

    useImperativeHandle(ref, () => ({
      resetForm: (values?: Partial<PersonalAreaProfileFormFieldsTypes>) => {
        formMethods?.reset({
          ...values,
        });
      },
    }));

    return (
      <form className="w-full" onSubmit={formMethods.handleSubmit(onSubmit)}>
        <FormProvider {...formMethods}>
          <div className="w-full flex flex-col gap-8 items-center">
            <PersonalAreaProfileFormFields
              labels={labels}
              materialsList={materialsList}
              businessRelationshipList={businessRelationshipList}
              countriesList={countriesList}
              statesList={statesList}
            />
            <PrivacyFormFields labels={labels} consents={consents} />
            {/* Submit button */}
            <SubmitButton disabled={!isSubmitDisabled}>{labels.submit}</SubmitButton>
          </div>
        </FormProvider>
      </form>
    );
  }
);
